import { render, staticRenderFns } from "./TakePhotos.vue?vue&type=template&id=8f324e12&scoped=true"
import script from "./TakePhotos.vue?vue&type=script&lang=js"
export * from "./TakePhotos.vue?vue&type=script&lang=js"
import style0 from "./TakePhotos.vue?vue&type=style&index=0&id=8f324e12&prod&scoped=true&lang=css"
import style1 from "./TakePhotos.vue?vue&type=style&index=1&id=8f324e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f324e12",
  null
  
)

export default component.exports